import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import styles from '../../../TerminateEmployeeAccess.module.scss';
import Card from '../../../../../../../../components/UI/MDC/Card/Card';
import { Headline4 } from '../../../../../../../../components/UI/MDC/Typography/Typography';
import ReviewApps from './components/ReviewApps';
import ReviewMobileDevices from './components/ReviewMobileDevices';
import ReviewBadges from './components/ReviewBadges';
import ReviewServiceAccounts from './components/ReviewServiceAccounts';
import StaffMemberInformationCard from '../../../../../../components/StaffMemberInformation/StaffMemberInformationCard';
import { getDefaultTerminationDate } from '../../../_utils';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Alert from '@mui/material/Alert';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
const ReviewInformation = ({
	formik,
	universalTerminationDate,
	setUniversalTerminationDate,
	terminateAsap,
	setTerminateAsap,
}) => {
	const staffCount = formik?.values?.staffMembersForReview?.length || 0;
	const isPlural = staffCount > 1;
	const alertMessage = `Note: If ${isPlural ? 'any of these employees are' : 'this employee is'}
		the organizer${isPlural ? 's' : ''} of any Outlook meetings, then these meetings will automatically be cancelled per Microsoft guidance.
		This is to prevent corrupted/un-editable meetings.`;
	const nextStepsMessage = `Next Steps: Please reschedule (or delegate someone to reschedule) any meetings organized by the terminated employee${isPlural ? 's' : ''}. 
		Due to Microsoft limitations, a meeting organizer cannot be changed or updated once an employee's account has been deactivated.`;

	return (
		<Card xlarge>
			<Headline4>Review information </Headline4>
			<TerminationDateSelect
				value={universalTerminationDate}
				handleChange={value => setUniversalTerminationDate(value)}
			/>
			<TerminationTimeSelect
				terminateAsap={terminateAsap}
				setTerminateAsap={setTerminateAsap}
			/>

			{formik?.values?.staffMembersForReview?.map(
				(staffMember, index) => {
					return (
						<StaffMemberInfo
							staffMember={staffMember}
							index={index}
							formik={formik}
							key={staffMember?.fiId}
						/>
					);
				},
			)}

			<Alert severity='warning' className={styles.alert_box}>
				{alertMessage}
				<br /><br />
				{nextStepsMessage}
			</Alert>
		</Card>
	);
};

export default ReviewInformation;

//internal
const StaffMemberInfo = ({ staffMember, index, formik }) => {
	return (
		<>
			<div className={styles.margin_top_small}>
				<Accordion className={styles.accordion} defaultExpanded>
					<AccordionSummary
						className={styles.accordion_summary}
						expandIcon={
							<ArrowDownwardIcon
								className={styles.accordion_summary}
							/>
						}
						aria-controls={'StaffMember-content-' + index}
						id={'StaffMember-header-' + index}
					>
						<Typography>
							{staffMember?.lastName +
								', ' +
								staffMember?.firstName}
						</Typography>
					</AccordionSummary>
					<AccordionDetails className={styles.accordion_details}>
						<StaffMemberInformationCard
							staffMember={staffMember}
							formik={formik}
							actions={[
								<StaffMemberTerminationEmailList
									staffMember={staffMember}
									index={index}
									formik={formik}
								/>,
							]}
						/>
						{/* apps */}
						<ReviewApps
							staffMember={staffMember}
							index={index}
							formik={formik}
						/>
						{/*Mobile Devices */}
						<ReviewMobileDevices
							staffMember={staffMember}
							index={index}
							formik={formik}
						/>
						{/*Badges */}
						<ReviewBadges
							staffMember={staffMember}
							index={index}
							formik={formik}
						/>
						{/*Service Accounts */}
						<ReviewServiceAccounts
							staffMember={staffMember}
							index={index}
							formik={formik}
						/>
					</AccordionDetails>
				</Accordion>
			</div>
		</>
	);
};

const TerminationDateSelect = ({
	value = getDefaultTerminationDate(),
	handleChange = e => {
		console.log(e.target.value);
	},
}) => {
	const currentYear = new Date().getFullYear();
	let maxDate = new Date();
	maxDate.setFullYear(currentYear + 1);

	return (
		<>
			<label for='StartDate'>Termination Date: </label>
			{/* <DateSelect
				name='StartDate'
				onChange={handleChange}
				value={value}
				extras={{
					yearStart: currentYear,
					yearEnd: currentYear + 1,
				}}
			/> */}
			<DatePicker
				label='Termination Date'
				value={dayjs(value)}
				onChange={newValue => handleChange(newValue.toDate())}
				maxDate={dayjs(maxDate)}
				minDate={dayjs(new Date())}
				sx={{ maxWidth: '25vw' }}
			/>
		</>
	);
};

const TerminationTimeSelect = ({ setTerminateAsap }) => {
	//return a radio button component with 'asap' as the value
	const handleChange = event => {
		setTerminateAsap(event.target.checked);
	};
	return (
		<FormControlLabel
			control={<Checkbox onChange={handleChange} />}
			label='Terminate staff members immediately, otherwise will take place at 12:00 AM on the selected date'
		/>
	);
};

const StaffMemberTerminationEmailList = ({ staffMember, index, formik }) => {
	//display error text if email list is not a semicolon delimited list of email addresses
	const handleEmailListChange = e => {
		let updatedSelected = [...formik.values.staffMembersForReview];
		updatedSelected[index].terminationEmailList = e.target.value;
		formik.setFieldValue('staffMembersForReview', updatedSelected);
	};

	const isValidEmailList = () => {
		const emails = staffMember?.terminationEmailList
			? staffMember?.terminationEmailList
			: staffMember?.supervisorEmail ?? '';

		const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

		return emails
			.split(';')
			.every(email => emailPattern.test(email.trim()));
	};

	return (
		<TextField
			label='Notify Email Recipient List'
			helperText='Multiple Email Addresses should be formatted as a semicolon delimited list (ex. user1@UPMC.edu;user2@UPMC.edu;user3@UPMC.edu)'
			value={
				staffMember?.terminationEmailList
					? staffMember?.terminationEmailList
					: staffMember?.supervisorEmail
			}
			onChange={e => handleEmailListChange(e)}
			error={!isValidEmailList()}
		/>
	);
};
